var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(-1200 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 100,
    height: 100,
    transform: "translate(1200 489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(901 178.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(316 327.044)",
    fill: "#2e8bfe",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 32.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(329.369 348.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1-2",
    "data-name": "Rectangle 1",
    d: "M0,0H23.593a3.932,3.932,0,0,1,3.932,3.932V20.447H2.359A2.359,2.359,0,0,1,0,18.088Z",
    transform: "translate(1.005 1.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M369.443,362.828l8.173-6.026s1.79-.895,1.85,1.372,0,17.779,0,17.779-.716,1.966-2.208.6-7.816-5.728-7.816-5.728Z",
    transform: "translate(-340.564 -354.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M5.129,22.82a4.691,4.691,0,0,1-4.417-2.6A6.655,6.655,0,0,1,0,17.729V0H13.566a.786.786,0,0,1,0,1.573H1.573v16.1a5.1,5.1,0,0,0,.551,1.872,3.13,3.13,0,0,0,3,1.71H26.793c.236-.039,1.193-.254,1.193-1.136V7.008A5.752,5.752,0,0,0,26.7,3.086a5.5,5.5,0,0,0-4.218-1.517H18.235a.786.786,0,1,1,0-1.573h4.247A6.978,6.978,0,0,1,27.87,2.031a6.967,6.967,0,0,1,1.685,4.256L36.417,1.2l.042-.02a2.532,2.532,0,0,1,2.319-.138,2.359,2.359,0,0,1,.981,2.219v10.3H38.186V3.254c0-.587-.131-.819-.2-.86a1.07,1.07,0,0,0-.72.131L29.558,8.243v7.028L37.7,21.045a.749.749,0,0,0,.385.055,1,1,0,0,0,.1-.562V17.281h1.573v3.257a2.064,2.064,0,0,1-.841,1.9,1.68,1.68,0,0,1-.906.248,2.568,2.568,0,0,1-1.044-.236l-.059-.028L29.558,17.2v2.91A2.532,2.532,0,0,1,28.2,22.394a3.69,3.69,0,0,1-1.251.422l-.046,0Z",
    transform: "translate(0 0.018)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.9975c05aff82d18c2399153204750796.svg";
export { ForwardRef as ReactComponent };